import React from 'react';

function PageTitle(props: { title: string }) {
  return (
    <h1 className="fs-4 text-start mt-3 mb-3">{props.title}</h1>
  );
}

export default PageTitle;
